import { createActionGroup, props } from '@ngrx/store';
import {
  HemsFeaturesPresentSincePayload,
  HemsFeaturesPresentSinceResponse,
  PropertySincePayload,
  ViError,
} from '@vi-iot/client';

import { DeviceWithAvailableFeatures } from './analytics.model';

export namespace AnalyticsActions {
  export const loadAvailableChronosFeatures = createActionGroup({
    source: 'ANALYTICS Load Available Chronos Features',
    events: {
      attempt: props<PropertySincePayload>(),
      success: props<{
        deviceWithAvailableFeatures: DeviceWithAvailableFeatures;
      }>(),
      error: props<{
        error: any;
      }>(),
    },
  });
  export const hemsFeaturesPresentSince = createActionGroup({
    source: 'ANALYTICS HEMS features present since',
    events: {
      attempt: props<{ hemsFeaturesPresentSincePayload: HemsFeaturesPresentSincePayload }>(),
      success: props<{
        hemsFeaturesPresentSince: HemsFeaturesPresentSinceResponse;
      }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });
}
